
const m = window.require("discourse/components/topic-status");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
